import axios from 'axios'
import { URLS } from '../factories'

export default {
    getContentById (state, id, depth = 0) {
        const requestURL = state.isProduction ? URLS.production.dotCMSApiUrl : URLS.replica.dotCMSApiUrl
        const url = requestURL + `/api/content/id/${id}/depth/${depth}`
        return axios.get(url, { timeout: 30000 })
    }
}